<template>
  <a-modal
    title="编辑你的加价"
    :visible="visible"
    :width="560"
    :footer="null"
    destroyOnClose
    wrapClassName="related-account-edit-markup-dialog"
    @cancel="handleClose"
  >
    <a-spin :spinning="detailLoading">
      <div class="field-block">
        <div class="field-head">
          <div class="field-label">
            加价百分点 :
          </div>
          <a-radio-group
            :value="markupEnabled"
            class="enable-radio"
            @change="(e) => onEnabledChange('markup', e)"
          >
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">关闭</a-radio>
          </a-radio-group>
        </div>
        <div class="field-row">
          <a-input
            v-model="form.markupPoints"
            placeholder="如 5.35"
            allow-clear
            :disabled="!markupEnabled"
          />
          <a-button
            type="primary"
            icon="save"
            :loading="markupSaving"
            :disabled="!markupEnabled"
            @click="onSaveMarkup"
          >
            保存百分点
          </a-button>
        </div>
      </div>

      <div class="field-block">
        <div class="field-head">
          <div class="field-label">
            固定加价 (元)：
          </div>
          <a-radio-group
            :value="flatEnabled"
            class="enable-radio"
            @change="(e) => onEnabledChange('flat', e)"
          >
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">关闭</a-radio>
          </a-radio-group>
        </div>
        <div class="field-row">
          <a-input
            v-model="form.flatYuan"
            placeholder="如 5 (元)"
            allow-clear
            :disabled="!flatEnabled"
          />
          <a-button
            type="primary"
            icon="save"
            :loading="flatSaving"
            :disabled="!flatEnabled"
            @click="onSaveFlat"
          >
            保存固定加价
          </a-button>
        </div>
      </div>

      <div class="field-block">
        <div class="field-label">备注 (可选)</div>
        <a-input v-model="form.remark" placeholder="请输入备注" allow-clear />
      </div>

    </a-spin>
  </a-modal>
</template>

<script>
export default {
  name: 'RelatedAccountEditMarkupDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      markupSaving: false,
      flatSaving: false,
      markupEnabled: true,
      flatEnabled: false,
      form: {
        markupPoints: '0',
        flatYuan: '0',
        remark: ''
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  methods: {
    /**
     * 打开弹窗回显：GET /hkdl/config/admin/managers/self
     */
    loadDetail() {
      this.form = {
        markupPoints: '0',
        flatYuan: '0',
        remark: ''
      }
      this.markupEnabled = true
      this.flatEnabled = false
      this.detailLoading = true
      return this.getHttpServices()
        .getSourceService()
        .get('/hkdl/config/admin/managers/self')
        .then(res => {
          const item = res || {}
          const markupNum = Number(item.markupPoints)
          const fenNum = Number(item.flatFen)
          // 接口返回分 → 前端按元展示
          const yuan = Number.isFinite(fenNum) ? fenNum / 100 : 0
          this.form = {
            markupPoints: Number.isFinite(markupNum) ? String(markupNum) : '0',
            flatYuan: String(yuan),
            remark: item.remark || ''
          }
          this.syncEnabledFromValues()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取加价信息失败，请重试')
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    /** 有固定加价且倍率为 0 时启用固定，否则启用倍率 */
    syncEnabledFromValues() {
      const markup = Number(this.form.markupPoints) || 0
      const flat = Number(this.form.flatYuan)
      const hasFlat = Number.isFinite(flat) && flat > 0
      if (hasFlat && markup === 0) {
        this.flatEnabled = true
        this.markupEnabled = false
      } else {
        this.markupEnabled = true
        this.flatEnabled = false
      }
    },
    parseRadioEnabled(e) {
      const raw = e && e.target ? e.target.value : e
      return raw === true || raw === 'true'
    },
    /**
     * 互斥：启用一方时关闭另一方；关闭项清 0 并立即保存
     * 逻辑同 GlobalMarkupComponent
     */
    onEnabledChange(type, e) {
      const enabled = this.parseRadioEnabled(e)
      if (type === 'markup' && enabled === this.markupEnabled) return
      if (type === 'flat' && enabled === this.flatEnabled) return

      if (type === 'markup') {
        if (enabled) {
          this.markupEnabled = true
          this.flatEnabled = false
          this.clearAndSaveFlat()
        } else {
          this.markupEnabled = false
          this.flatEnabled = true
          this.clearAndSaveMarkup()
        }
      } else if (enabled) {
        this.flatEnabled = true
        this.markupEnabled = false
        this.clearAndSaveMarkup()
      } else {
        this.flatEnabled = false
        this.markupEnabled = true
        this.clearAndSaveFlat()
      }
    },
    clearAndSaveMarkup() {
      this.form.markupPoints = '0'
      return this.submitMarkup(0, '加价百分点已关闭并清零')
    },
    clearAndSaveFlat() {
      this.form.flatYuan = '0'
      return this.submitFlat(0, '固定加价已关闭并清零')
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    onSaveMarkup() {
      if (!this.markupEnabled) {
        this.$message.warning('请先启用加价百分点')
        return
      }
      const raw = String(this.form.markupPoints == null ? '' : this.form.markupPoints).trim()
      const markupPoints = Number(raw)
      if (!Number.isFinite(markupPoints)) {
        this.$message.warning('请输入有效的加价百分点')
        return
      }
      if (markupPoints < 0 || markupPoints > 100) {
        this.$message.warning('加价百分点范围为 0~100')
        return
      }
      if (!/^\d+(\.\d{1,2})?$/.test(raw)) {
        this.$message.warning('最多支持 2 位小数')
        return
      }
      return this.submitMarkup(markupPoints, '保存百分点成功')
    },
    /**
     * POST /hkdl/config/admin/markup
     */
    submitMarkup(markupPoints, successMsg) {
      this.markupSaving = true
      return this.getHttpServices()
        .getSourceService()
        .post('/hkdl/config/admin/markup', { markupPoints })
        .then(() => {
          this.$message.success(successMsg || '保存百分点成功')
          this.$emit('success')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '保存百分点失败，请重试')
        })
        .finally(() => {
          this.markupSaving = false
        })
    },
    onSaveFlat() {
      if (!this.flatEnabled) {
        this.$message.warning('请先启用固定加价')
        return
      }
      const raw = String(this.form.flatYuan == null ? '' : this.form.flatYuan).trim()
      const yuan = Number(raw)
      if (!Number.isFinite(yuan)) {
        this.$message.warning('请输入有效的固定加价金额')
        return
      }
      if (yuan < 0 || yuan > 10000) {
        this.$message.warning('固定加价范围为 0~10000 元')
        return
      }
      // 最多 2 位小数（对应分）
      if (!/^\d+(\.\d{1,2})?$/.test(raw)) {
        this.$message.warning('最多支持 2 位小数')
        return
      }
      return this.submitFlat(yuan, '保存固定加价成功')
    },
    /**
     * POST /hkdl/config/admin/flat
     * body: { flatFen: int } 范围 0~1000000（分）；前端填元后 ×100 提交
     */
    submitFlat(yuan, successMsg) {
      const flatFen = Math.round(Number(yuan) * 100)
      if (flatFen < 0 || flatFen > 1000000) {
        this.$message.warning('固定加价超出接口允许范围')
        return Promise.resolve()
      }
      this.flatSaving = true
      return this.getHttpServices()
        .getSourceService()
        .post('/hkdl/config/admin/flat', { flatFen })
        .then(() => {
          this.$message.success(successMsg || '保存固定加价成功')
          this.$emit('success')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '保存固定加价失败，请重试')
        })
        .finally(() => {
          this.flatSaving = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.field-block {
  margin-bottom: 20px;
}

.field-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.field-label {
  flex: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5;
}

.enable-radio {
  flex-shrink: 0;
  white-space: nowrap;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;

  .ant-input {
    flex: 1;
  }

  .ant-btn {
    flex-shrink: 0;
  }
}
</style>
